import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import ResetPassword from './ResetPassword';

const NotFound = Loadable(lazy(() => import('./NotFound')));
const ForgotPassword = Loadable(lazy(() => import('./ForgotPassword')));
const JwtLogin = Loadable(lazy(() => import('./JwtLogin')));
const OtpVerification = Loadable(lazy(() => import('./OtpVerification')));

const sessionRoutes = [
  { path: '/session/signin', element: <JwtLogin /> },
  { path: '/session/forgot-password', element: <ForgotPassword /> },
  { path: '/session/404', element: <NotFound /> },
  { path: '/session/resetPassword', element: <ResetPassword /> },
  { path: '/session/otp-verification', element: <OtpVerification /> },
];

export default sessionRoutes;
